module.exports = function() {
  return new Worker(__webpack_public_path__ + "70ff6c7077a34556f903.worker.js");
};